import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { EAccountServiceCode, IAdditionalFields, IResultPageState } from '@common/models';
import { BaseFpxFormComponent } from '@common/base-components';
import { RequestChequeBookHelper, RequestChequeBookState } from './services/request-cheque-book.helper';
import { AccountsService } from 'src/app/services/accounts/accounts.service';
import { REFERENCE_KEY, REQUESTREFERENCE } from '@common/constants';
import { ResultPageService, ResultService } from '@common/services';
import { CommonService } from 'src/app/common.service';
import { TranslateService } from '@ngx-translate/core';
import { RetailStock } from 'src/app/retail-common.service';
import { ServiceRequestHistoryService } from 'src/app/services/service-request-history/service-request-history.service';

@Component({
  selector: 'app-request-cheque-book',
  templateUrl: './request-cheque-book.component.html',
  styleUrls: ['./request-cheque-book.component.scss'],
  providers: [
    RequestChequeBookHelper
  ]
})
export class RequestChequeBookComponent extends BaseFpxFormComponent<RequestChequeBookHelper, RequestChequeBookState> {
  serviceCode: any;
  requestReference: any;
  data: any;
  accDisable: any = false;

  constructor(
    _formBuilder: FormBuilder,
    private _router: Router,
    public _requestChequeBookHelper: RequestChequeBookHelper,
    private _accountsService: AccountsService,
    private _resultService: ResultService,
    private _commonService: CommonService,
    protected translate:TranslateService,
    private _retailStock:RetailStock,
    private _serviceRequestHistoryService: ServiceRequestHistoryService) {
    super(_formBuilder, _router, _requestChequeBookHelper);
    this.serviceCode = this._router.getCurrentNavigation()?.extras?.state?.serviceCode || '';
  }

  accType: any = "CA";

  override doPreInit() {
    this.initializeForm();
    this.requestReference = this._serviceRequestHistoryService.getTrackerDetails()?.requestReference;
    if(this.requestReference) {
      this.state.disableMode = true;
      this._requestChequeBookHelper.fetchChequeBookDetails(this.requestReference, this.formGroup);
    }
    if (this._commonService.isDesktop()) {
      this._retailStock.backBtnUrl = ['home','transactions'];
      this._retailStock.searchRequired = true;
      this._retailStock.serviceDescription = 'CHEQUEBOOKREQ.title';
     
    }
  }
  protected doDestroy(): void {
    this._retailStock.backBtnUrl = undefined;
    this._requestChequeBookHelper.resetState();
  }

  initializeForm() {
    const accountNumber = this.getRoutingParam(REFERENCE_KEY);
    this.addFormControl("dlvryOption", "", [], [], 'change');
    this.formGroup.controls['dlvryOption'].setValue('1');
    this.addFormControl("dlvryBranch", "", [Validators.required]);
    this.addFormControl("noOfChqBooks", "", [Validators.required], [], 'change');
    this.addFormControl("noOfLeaves", "", [Validators.required], [], 'change');
    this.addFormControl("accountNumber", accountNumber, [Validators.required]);
    this.addFormControl("remarks", "", [], [], 'change');
  }

  protected override doPostInit() { }

  override doConfirm(formGroup: FormGroup) {
    this._requestChequeBookHelper.doConfirm(formGroup.value, 
      (res) => {
        this.navigateToResultPage(this._resultService.resultPageData);
      },
      (err) => {
        this.navigateToResultPage(this._resultService.resultPageData);
      });
  }
  submit(): void {
    this.formGroup.disable({ emitEvent: false });
    this.state.disableMode = true;
  }
  edit() {
    this.formGroup.enable({ emitEvent: false });
    this.state.disableMode = false;
  }
  reset() {
    this.formGroup.get('dlvryBranch').reset();
    this.formGroup.get('noOfChqBooks').reset();
    this.formGroup.get('noOfLeaves').reset();
    this.formGroup.get('remarks').reset();
  }

}
